<template>
	<div v-if="goods_detail" class="cmbc_detail bg_FFFFFF width_100">
		<naviBack type='detail' title="" background="none" />
		<div class="cmbc_detail_swiper width_100">
			<van-swipe :autoplay="5000" @change="swiperChange" :show-indicators="false">
				<van-swipe-item v-for="(item_sw,index_sw) in goods_detail.thumbList" :key="'sw'+index_sw">
					<van-image class="cmbc_detail_swiper_item width_100" fit="cover" :src="item_sw" />
				</van-swipe-item>
			</van-swipe>
			<div class="cmbc_detail_swiper_ind display_center_center">
				<div :class="[{'cmbc_detail_swiper_ind_itemS':cur_swi_index==index_ind},'cmbc_detail_swiper_ind_item']"
					v-for="(item_ind,index_ind) in goods_detail.thumbList" :key="'ind'+index_ind"></div>
			</div>
		</div>
		<div class="cmbc_detail_body width_100 border_radius_16">
			<div class="cmbc_detail_body_1 width_100 font_size_36 color_333333 font_weight_600">
				{{goods_detail.serviceName}}</div>
			<div class="cmbc_detail_body_2 width_100 border_radius_16 bg_FFFFFF">
				<div @click="openMap()" class="cmbc_detail_body_21">
					<div class="cmbc_detail_body_211 width_100 font_size_30 color_333333">
						{{goods_detail.venueInfo.venueName}}</div>
					<div class="cmbc_detail_body_212 color_999999 font_size_24 width_fit text_ellipsis">
						{{goods_detail.venueInfo.address}}</div>
				</div>
				<div @click="getStockInfo()" class="cmbc_detail_body_22 width_100">
					<div class="cmbc_detail_body_221 width_100 color_333333 font_size_28 display_start_center">请选择时间
					</div>
				</div>
			</div>
			<div class="cmbc_detail_body_3 width_100 border_radius_16 bg_FFFFFF">

				<div v-if="goods_detail.venueInfo.openTimeDesc||goods_detail.venueInfo.facilitiesList.parking||goods_detail.venueInfo.facilitiesList.swimmingPool"
					class="cmbc_detail_body_31 width_100 display_start_center font_size_30 color_333333 font_weight_600">
					场馆详情
				</div>
				<div class="cmbc_detail_body_32 width_100">
					<div v-if="goods_detail.tips" class="width_100 font_size_26 color_666666 display_start_start">
						<div class="text_ellipsis2 color_333333">温馨提示：</div>
						<div v-html="goods_detail.tips" class="cmbc_detail_body_32_preline"></div>
					</div>
					
					<div v-if="goods_detail.venueInfo.openTimeDesc" class="width_100 font_size_26 color_666666 display_start_start">
						<div class="text_ellipsis2 color_333333">营业时间：</div>
						<div v-html="goods_detail.venueInfo.openTimeDesc" class="cmbc_detail_body_32_preline"></div>
					</div>
					<div v-if="goods_detail.venueInfo.facilitiesList.swimmingPool" class="width_100 font_size_26 color_666666 display_start_start">
						<div class="text_ellipsis2 color_333333">泳池规格：</div>
						<div v-html="goods_detail.venueInfo.facilitiesList.swimmingPool" class="cmbc_detail_body_32_preline"></div>
					</div>
					<div v-if="goods_detail.venueInfo.facilitiesList.parking" class="width_100 font_size_26 color_666666 display_start_start">
						<div class="text_ellipsis2 color_333333">停车服务：</div>
						<div v-html="goods_detail.venueInfo.facilitiesList.parking" class="cmbc_detail_body_32_preline"></div>
					</div>
				</div>

				<div v-if="goods_detail.bookingInstructions"
					class="cmbc_detail_body_31 width_100 font_size_30 color_333333 font_weight_600">预约须知</div>
				<div v-if="goods_detail.bookingInstructions"
					class="cmbc_detail_body_32 width_100 font_size_26 color_666666"
					v-html="goods_detail.bookingInstructions"></div>
				<div v-if="goods_detail.cancellationPolicy"
					class="cmbc_detail_body_31 width_100 font_size_30 color_333333 font_weight_600">退订规则</div>
				<div v-if="goods_detail.cancellationPolicy"
					class="cmbc_detail_body_32 width_100 font_size_26 color_666666"
					v-html="goods_detail.cancellationPolicy"></div>
					
				<!-- <div v-if="goods_detail.tips"
					class="cmbc_detail_body_31 width_100 font_size_30 color_333333 font_weight_600">温馨提示</div>
				<div v-if="goods_detail.tips"
					class="cmbc_detail_body_32 width_100 font_size_26 color_666666"
					v-html="goods_detail.tips"></div> -->
					
				<div v-if="goods_detail.venueInfo.introduce"
					class="cmbc_detail_body_31 width_100 font_size_30 color_333333 font_weight_600">场馆介绍</div>
				<div v-if="goods_detail.venueInfo.introduce"
					class="cmbc_detail_body_32 width_100 font_size_26 color_666666"
					v-html="goods_detail.venueInfo.introduce"></div>
			</div>
		</div>
		<div class="cmbc_detail_bottom width_100 bg_FFFFFF">
			<div @click="getStockInfo()" class="width_100 color_ffffff display_center_center font_size_32">立即预订</div>
		</div>
		<timePop :goods_detail="goods_detail" ref='time_pop' />
	</div>
</template>

<script>
	import naviBack from '../components/navi_back.vue';
	import timePop from '../components/time_pop.vue';
	import {
		getVenueServiceDetail
	} from '../api/api.js'
	export default {
		components: {
			naviBack,
			timePop
		},
		name: "",
		data() {
			return {
				cur_swi_index: 0,
				goods_detail: null,
			};
		},
		mounted() {
			this.$RCLoading.show();
			this.getGoodsDetail()
		},
		methods: {
			async getGoodsDetail() {
				var $this = this
				var params = {
					serviceId: this.$route.params.service_id
				}
				try {
					var res = await getVenueServiceDetail(params)
					console.log(res);
					$this.goods_detail = res.data
					if(res.data.noticeContent){
						$this.$dialog.alert({
						  title: '温馨提示',
						  message: res.data.noticeContent,
						  messageAlign:'left',
						  confirmButtonColor:'#F77F28'
						}).then(() => {
						  // on close
						});
					}
					$this.$RCLoading.hide();
				} catch (error) {
					$this.$RCLoading.hide();
					//TODO handle the exception
				}
			},
			swiperChange(e) {
				this.cur_swi_index = e
			},
			getStockInfo() {
				this.$refs.time_pop.getStockInfo()
			},
			openMap(){
				console.log(this.goods_detail);
				window.location.href =
					`https://uri.amap.com/marker?position=${this.goods_detail.venueInfo.longitude},${this.goods_detail.venueInfo.latitude}&name=${this.goods_detail.venueInfo.address}`;
			}
		},
	};
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750 * 100vw;

	.cmbc_detail {
		min-height: 100vh;
		background: #F6F7F9;

		.cmbc_detail_swiper {
			position: relative;

			.cmbc_detail_swiper_item {
				height: 580*@vm_base;
			}

			.cmbc_detail_swiper_ind {
				position: absolute;
				bottom: 60*@vm_base;
				right: 30*@vm_base;

				.cmbc_detail_swiper_ind_item {
					width: 10*@vm_base;
					height: 10*@vm_base;
					background: rgba(255, 255, 255, 0.4);
					border-radius: 50%;
					margin-left: 5*@vm_base;
				}

				.cmbc_detail_swiper_ind_itemS {
					background: rgba(255, 255, 255, 1);
				}
			}
		}

		.cmbc_detail_body {
			position: relative;
			margin-top: -30*@vm_base;
			background: #F6F7F9;
			padding: 30*@vm_base 20*@vm_base 160*@vm_base 20*@vm_base;
			padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 160*@vm_base);
			padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 160*@vm_base);

			.cmbc_detail_body_1 {
				padding: 0 20*@vm_base;
				line-height: 1.3;
			}

			.cmbc_detail_body_2 {
				margin-top: 20*@vm_base;
				padding: 24*@vm_base 30*@vm_base 0 30*@vm_base;

				.cmbc_detail_body_21 {
					.cmbc_detail_body_211 {
						padding-left: 50*@vm_base;
						line-height: calc(40 / 30);
						background-image: url(../resource/location.png);
						background-position: left top;
						background-repeat: no-repeat;
						background-size: auto 40*@vm_base;
					}

					.cmbc_detail_body_212 {
						padding-left: 50*@vm_base;
						margin-top: 10*@vm_base;
						line-height: calc(34 / 24);
						max-width: 100%;
						padding-right: 40*@vm_base;
						background-image: url(../resource/fly.png);
						background-position: right center;
						background-repeat: no-repeat;
						background-size: auto 100%;
					}
				}

				.cmbc_detail_body_22 {
					background-image: url(../resource/more_333333.png);
					background-size: 30*@vm_base;
					background-position: right center;
					background-repeat: no-repeat;
					padding-right: 40*@vm_base;
					border-top: 1*@vm_base solid #D9D9D9;
					margin-top: 15*@vm_base;

					.cmbc_detail_body_221 {
						padding-left: 50*@vm_base;
						background-image: url(../resource/time.png);
						background-size: 40*@vm_base;
						background-position: left center;
						background-repeat: no-repeat;
						height: 92*@vm_base;
					}
				}
			}

			.cmbc_detail_body_3 {
				padding: 10*@vm_base 30*@vm_base 30*@vm_base 30*@vm_base;
				margin-top: 20*@vm_base;

				.cmbc_detail_body_31 {
					margin-top: 20*@vm_base;
				}

				.cmbc_detail_body_32 {
					line-height: calc(42 / 26);
					margin-top: 16*@vm_base;
					white-space: pre-line;

					div {
						line-height: calc(42 / 26);
					}
					.cmbc_detail_body_32_preline{
						white-space: pre-line;
					}
				}

				.cmbc_detail_body_33 {
					margin-top: 0;
				}
			}
		}

		.cmbc_detail_bottom {
			position: fixed;
			bottom: 0;
			left: 0;
			z-index: 1;
			border-radius: 16*@vm_base 16*@vm_base 0 0;
			padding: 25*@vm_base 75*@vm_base;
			padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 25*@vm_base);
			padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 25*@vm_base);
			box-shadow: -4*@vm_base -4*@vm_base 6*@vm_base rgba(243, 207, 166, 0.5);
			border-radius: 16*@vm_base 16*@vm_base 0 0;
			div {
				height: 80*@vm_base;
				background: linear-gradient(233deg, #FB8027 0%, #FFA663 100%);
				border-radius: 40*@vm_base;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/detail_1.vue